
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import {
  collection,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";

import { auth, db } from "../firebase";
import "./VolatilityHeader.css";

export default function VolatilityHeader({
  balance: providedBalance,
  userInitial,
  onDeposit = null,
  onMenu = null,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const [firestoreBalance, setFirestoreBalance] = useState(0);

  // Pata username iliyohifadhiwa wakati wa login.
  const [username] = useState(
    () => (localStorage.getItem("username") || "").trim()
  );

  // Herufi ya kwanza ya username ndiyo itakayoonekana kwenye logo.
  const initial = (
    userInitial || username.charAt(0) || "?"
  ).toUpperCase();

  const menuRef = useRef(null);

  const menuItems = [
    { label: "Game Hub", path: "/volatility" },
    { label: "Bulk", path: "/bulk" },
    { label: "Bots", path: "/auto-trade" },
   
    { label: "Records", path: "/Recorder" },
    { label: "Developers", path: "/developers" },
    { label: "History", path: "/volatility-history" },
    { label: "Account", path: "/account" },
  ];

  /*
   * READ LIVE BALANCE FROM FIRESTORE
   * Collection: users
   * Lookup field: username
   * Balance field: usdtBalanceOther
   */
  useEffect(() => {
    const storedUsername = (
      localStorage.getItem("username") || ""
    ).trim();

    if (!storedUsername) {
      setFirestoreBalance(0);
      return undefined;
    }

    const usersQuery = query(
      collection(db, "users"),
      where("username", "==", storedUsername)
    );

    const unsubscribe = onSnapshot(
      usersQuery,
      (snapshot) => {
        if (snapshot.empty) {
          setFirestoreBalance(0);
          return;
        }

        const userData = snapshot.docs[0].data();
        const amount = Number(userData.usdtBalanceOther);

        setFirestoreBalance(
          Number.isFinite(amount) ? amount : 0
        );
      },
      (error) => {
        console.error(
          "Failed to read account balance:",
          error
        );
      }
    );

    return unsubscribe;
  }, []);

  /*
   * Use a supplied balance if the parent provides one.
   * Otherwise use the live Firestore balance.
   */
  const balance =
    providedBalance !== undefined &&
    providedBalance !== null
      ? Number(providedBalance) || 0
      : firestoreBalance;

  const formattedBalance = Number(balance).toLocaleString(
    "en-US",
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  );

  /*
   * CLOSE MENU WHEN ROUTE CHANGES
   */
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  /*
   * CLOSE MENU WHEN CLICKING OUTSIDE
   */
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener(
        "mousedown",
        handleOutsideClick
      );

      document.addEventListener(
        "touchstart",
        handleOutsideClick
      );
    }

    return () => {
      document.removeEventListener(
        "mousedown",
        handleOutsideClick
      );

      document.removeEventListener(
        "touchstart",
        handleOutsideClick
      );
    };
  }, [menuOpen]);

  /*
   * BACK BUTTON
   */
  const handleBack = () => {
    if (loggingOut) return;
    navigate(-1);
  };

  /*
   * MENU TOGGLE
   */
  const handleMenuToggle = () => {
    if (loggingOut) return;

    setMenuOpen((previous) => !previous);

    if (typeof onMenu === "function") {
      onMenu();
    }
  };

  /*
   * CLOSE SIDE MENU
   */
  const handleMenuBack = () => {
    if (loggingOut) return;
    setMenuOpen(false);
  };

  /*
   * MENU NAVIGATION
   */
  const handleMenuNavigation = (path) => {
    if (loggingOut) return;

    setMenuOpen(false);
    navigate(path);
  };

  /*
   * DEPOSIT
   */
  
const handleDeposit = () => {
  if (loggingOut) return;

  setMenuOpen(false);

  if (typeof onDeposit === "function") {
    onDeposit();
    return;
  }

  navigate("/DepisitBFCOrder");
};

  /*
   * LOGOUT
   */
  const handleLogout = async () => {
    if (loggingOut) return;

    setLoggingOut(true);

    try {
      const loginLanguage =
        localStorage.getItem("loginLanguage") ||
        sessionStorage.getItem("loginLanguage");

      await signOut(auth);

      localStorage.clear();
      sessionStorage.clear();

      if (loginLanguage) {
        localStorage.setItem(
          "loginLanguage",
          loginLanguage
        );
      }

      setMenuOpen(false);

      navigate("/login", {
        replace: true,
      });
    } catch (error) {
      console.error("Logout failed:", error);
      setLoggingOut(false);

      alert("Failed to log out. Please try again.");
    }
  };

  return (
    <>
      {/* MAIN HEADER */}
      <header className="volatility-page-header">
        <div className="volatility-page-header-left">
          <button
            type="button"
            className="volatility-page-header-back"
            onClick={handleBack}
            aria-label="Go back"
            disabled={loggingOut}
          >
            ←
          </button>

          {/* HERUFI YA MWANZO YA USERNAME */}
          <div className="volatility-page-header-logo">
            {initial}
          </div>

          <div className="volatility-page-header-balance">
            <span className="balance-label">$</span>

            <span className="balance-value">
              {formattedBalance}
            </span>
          </div>
        </div>

        <div className="volatility-page-header-right">
          <button
            type="button"
            className="volatility-page-header-deposit"
            onClick={handleDeposit}
            disabled={loggingOut}
          >
            Deposit
          </button>

          <button
            type="button"
            className={
              menuOpen
                ? "volatility-page-header-menu active"
                : "volatility-page-header-menu"
            }
            onClick={handleMenuToggle}
            aria-label={
              menuOpen ? "Close menu" : "Open menu"
            }
            aria-expanded={menuOpen}
            disabled={loggingOut}
          >
            {menuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* SIDE MENU */}
      {menuOpen && (
        <>
          <div
            className="volatility-menu-overlay"
            onClick={() => setMenuOpen(false)}
            aria-hidden="true"
          />

          <aside
            ref={menuRef}
            className="volatility-side-menu"
          >
            <div className="volatility-side-menu-top">
              <button
                type="button"
                className="volatility-side-menu-back"
                onClick={handleMenuBack}
                aria-label="Close menu"
                disabled={loggingOut}
              >
                ←
              </button>

              <div className="volatility-side-menu-switches">
                <button
                  type="button"
                  className="volatility-currency-button active"
                  disabled
                >
                  USD
                </button>

                <button
                  type="button"
                  className="volatility-demo-button"
                  disabled
                >
                  DEMO
                </button>
              </div>
            </div>

            <div className="volatility-side-menu-divider" />

            <nav className="volatility-side-menu-nav">
              {menuItems.map((item) => (
                <button
                  key={item.path}
                  type="button"
                  className="volatility-side-menu-item"
                  onClick={() =>
                    handleMenuNavigation(item.path)
                  }
                  disabled={loggingOut}
                >
                  {item.label}
                </button>
              ))}
            </nav>

            <div className="volatility-side-menu-bottom">
              <button
                type="button"
                className="volatility-side-menu-logout"
                onClick={handleLogout}
                disabled={loggingOut}
              >
                {loggingOut
                  ? "Logging out..."
                  : "Log out"}
              </button>
            </div>
          </aside>
        </>
      )}
    </>
  );
}
